import { OfferModel } from '@/types'

import { SingleProductEditor } from './SingleProductEditor'
import { BuyXGetYEditor } from './BuyXGetYEditor'
import { VolumeDiscountEditor } from './VolumeDiscountEditor'
import { ComboFixedPriceEditor } from './ComboFixedPriceEditor'

interface Props {
  type: OfferModel.OfferType
  rules: Partial<OfferModel.OfferRules>
  onChange: (rules: Partial<OfferModel.OfferRules>) => void
}

export const CampaignOfferRulesEditor = ({ type, rules, onChange }: Props) => {
  switch (type) {
    case 'single_product':
      return (
        <SingleProductEditor
          rules={rules as Partial<OfferModel.SingleProductRules>}
          onChange={onChange}
        />
      )
    case 'buy_x_get_y':
      return (
        <BuyXGetYEditor
          rules={rules as Partial<OfferModel.BuyXGetYRules>}
          onChange={onChange}
        />
      )
    case 'volume_discount':
      return (
        <VolumeDiscountEditor
          rules={rules as Partial<OfferModel.VolumeDiscountRules>}
          onChange={onChange}
        />
      )
    case 'combo_fixed_price':
      return (
        <ComboFixedPriceEditor
          rules={rules as Partial<OfferModel.ComboFixedPriceRules>}
          onChange={onChange}
        />
      )
  }
}
